<template>
  <div class="promo-booster">
    <ProfessionalLabel
      v-if="isProfessionalRate"
      :professionalRateLabel="translate('rdProfessionalRateAppliedTooltip')"
    />
    <PromoLabel :show="showVoucher" :text="translate('srPromocodeApplied')" cssClass="promocode" />
    <PromoLabel
      :show="isSeniorTypeSearchApplied"
      :text="translate('srSeniorCitizenRate')"
      cssClass="promocode"
    />
    <PromoLabel
      :show="isAAACAAA_Applied"
      :text="translate('srAAACAAApplied')"
      cssClass="promocode"
    />
    <PromoLabel
      :show="isMilitaryApplied"
      :text="translate('srMilitaryApplied')"
      cssClass="promocode"
    />

    <div class="promocode booster" v-if="isCrowdDiscount">
      <span data-testid="crowd-label-text" class="from-price__crowd-label--text">
        {{ translate('rdCrowdDiscountApplied') }}
      </span>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import Stay from '@/multi-room-display/domain/Stay'
import PromoLabel from '@/components/PromoLabel'
import ExternalStorage from '@/services/ExternalStorage'
import SearchTypes from '@/domain/SearchTypes'
import { CrowdTypes } from '@/infrastructure/Configuration'
import ProfessionalLabel from '@/multi-room-display/components/stay/ProfessionalLabel'
const { mapGetters } = createNamespacedHelpers('multiRoomDisplay')

export default {
  name: 'Booster',
  components: {
    PromoLabel,
    ProfessionalLabel
  },
  props: {
    stay: {
      type: Stay
    },
    showPromoLabel: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    crowdTypes: CrowdTypes,
    isProfessionalRateActive: global.ConfigDynamic.isEnabled(
      global.configDynamicKey.ROOMDISPLAY_PROFESSIONAL_RATE_ACTIVE
    )
  }),
  computed: {
    ...mapGetters(['customer']),
    isProfessionalRate() {
      return (
        this.isProfessionalRateActive &&
        this.translate('rdProfessionalRateApplied') &&
        this.stay.professional
      )
    },
    showVoucher() {
      return this.stay.isVoucherApplied() && this.showPromoLabel
    },
    isSeniorTypeSearchApplied() {
      return this.getSearchType === SearchTypes.SENIOR && this.matchesSearch
    },
    isAAACAAA_Applied() {
      return this.getSearchType === SearchTypes.AAA && this.matchesSearch
    },
    isMilitaryApplied() {
      return this.getSearchType === SearchTypes.GOVERNMENT && this.matchesSearch
    },
    matchesSearch() {
      return Boolean(this.stay.jsonForIntegrateWithApi.matchesSearch)
    },
    getSearchType() {
      return ExternalStorage.url.params.searchType
    },
    isCrowdDiscount() {
      return (
        this.customer.crowd === CrowdTypes.DISCOUNT &&
        this.stay.hasDiscount() &&
        this.stay.crowdDiscount
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.promo-booster {
  display: flex;
  justify-content: center;
  align-items: center;
  justify-self: flex-end;
  gap: 8px;
  @media (max-width: 590px) {
    width: 100%;
    text-align: right;
  }
}
.promocode {
  border-radius: 35px;
  color: #50b065;
  font-size: 1.2rem;
  font-weight: 700;
  &.booster {
    color: #382246;
  }
}
</style>
